export default __webpack_public_path__ + "static/banner_background_xmas-6e52318885f8d14527ad00f7afd29a3e.png";